module.exports = __webpack_public_path__ + "875b531c9c280118d16e9fc9b146022c.svg";